export default {
    name: "help",
    methods: {
        open(){
            jQuery('#modal').modal('show');
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/header/help/help.js